import { render, staticRenderFns } from "./Enrollments.vue?vue&type=template&id=6b888b78&scoped=true&"
import script from "./Enrollments.vue?vue&type=script&lang=js&"
export * from "./Enrollments.vue?vue&type=script&lang=js&"
import style0 from "./Enrollments.vue?vue&type=style&index=0&id=6b888b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b888b78",
  null
  
)

export default component.exports